import React from 'react';
import {
  AtRiskCircleIcon,
  CriticalCircleIcon,
  GreenTickCircleOutlineIcon,
} from '@/assets/icons/icons';
import { GxpRequirementItem } from './types';

const ICONS_BY_STATUS: Record<GxpRequirementItem['status'], React.ReactNode> = {
  pass: <GreenTickCircleOutlineIcon />,
  fail: <CriticalCircleIcon width={16} height={16} />,
  warning: <AtRiskCircleIcon width={16} height={16} />,
};

interface RequirementsCardProps {
  requirements: GxpRequirementItem[];
}

const RequirementsCard: React.FC<RequirementsCardProps> = ({
  requirements,
}) => {
  return (
    <div className='gxp-card'>
      <div className='gxp-card__title'>Requirements</div>
      <div className='gxp-requirements-list'>
        {requirements.map((item) => (
          <div className='gxp-requirements-row' key={item?.key}>
            <span className='gxp-requirements-row__icon'>
              {ICONS_BY_STATUS[item?.status]}
            </span>
            <span className='gxp-requirements-row__label'>{item?.label}</span>
            <span className='gxp-requirements-row__description'>
              {item?.detail}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RequirementsCard;
